import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select, { components } from "react-select";

const Edit = ({ show, onClose }) => {

    const options_units = [
        { value: "Kilogram", label: "Kilogram / kg" },
        { value: "Litre", label: "Litre / L" },
        { value: "Tons", label: "Tons / LT" },
    ];

    const [setSelectedOption] = useState(null);
    const Group = (props) => (
        <div>
            <components.Group {...props} />
        </div>
    );
    // Icon

    const category = [
        { value: "0", label: "RelianceMart" },
        { value: "1", label: "Kannan Vegetable Shop" },
    ];
    const vendor = [
        { value: "0", label: "Kumar Vessels" },
        { value: "1", label: "Kitchen All rounder" },
    ];
    const groupedOptions_items = [
        {
            label: "Vegetables - Spinach",
            options: category,

        },
        {
            label: "Vessels - Frying Pan",
            options: vendor,
        },
    ];
    const raw_material_cat = [
        { value: "0", label: "Basmathi Rice" },
        { value: "1", label: "Ponni Rice" },
    ];
    const raw_material = [
        { value: "0", label: "Brinjal" },
        { value: "1", label: "Drum Stick" },
    ];
    const groupedOptions = [
        {
            label: "Grains",
            options: raw_material_cat,

        },
        {
            label: "Vegetables",
            options: raw_material,
        },
    ];

    const customStyles = {
        groupHeading: (provided) => ({
            ...provided,
            fontSize: '14px',  // Increase the font size for group labels
            fontWeight: 'bold',  // Optional: make the label bold
            color: '#333',  // Optional: change the text color
        }),
    };



    const vendor_list = [
        { value: "0", label: "Kannan Store" },
        { value: "1", label: "Krishan shop" },
        { value: "2", label: "Mithra Grocery" },
    ]

    return (
        <Modal show={show} size="md"  >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Purchase</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-4">
                            <label className="text-black font-w500 fs-7">Raw Material<span className="required">*</span></label>
                            <Select
                                defaultValue={raw_material_cat[0]}
                                options={groupedOptions}
                                components={{ Group }}
                                styles={customStyles}
                            />
                        </div>
                        <div className="col-lg-6 mb-4">
                            <label className="text-black font-w500 fs-7">Vendor<span className="required">*</span></label>
                            <Select
                                defaultValue={vendor_list[0]}
                                options={vendor_list}
                                components={{ Group }}
                                styles={customStyles}
                            />
                        </div>
                        <div className="col-lg-6 mb-4">
                            <label className="text-black font-w500 fs-7">Brand</label>
                            <input type="text" className="form-control" placeholder="Enter Brand" defaultValue={"Tata Sampann"} />
                        </div>
                        <div className='col-lg-12 mb-4'>
                            <div className='row'>
                                <div className='col-lg-6'>
                                    <label className="text-black font-w500 fs-7">Quantity<span className="required">*</span></label>
                                    <input type="text" className="form-control" placeholder="Enter Quantity" defaultValue={"10"} />
                                </div>
                                <div className='col-lg-6'>
                                    <label className="text-black font-w500 fs-7">Units<span className="required">*</span></label>
                                    <Select placeholder="Select Option Units"
                                        defaultValue={options_units[0]}
                                        onChange={setSelectedOption}
                                        options={options_units}
                                    />
                                </div>
                            </div>

                        </div>
                        <div className="col-lg-6 mb-4">
                            <label className="text-black font-w500 fs-7">Price Per Cost<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Price Per Cost" defaultValue={90} />
                        </div>
                        <div className="col-lg-6 mb-4">
                            <label className="text-black font-w500 fs-7">Total Cost<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Total Cost" defaultValue={900} />
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-3 mt-4">
                        <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link>
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={onClose}>Update Purchase</Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Edit;
